module.exports = __webpack_public_path__ + "static/media/gameflix_logo.040fd30c.png";